import React from 'react';

export interface OidcProviderHelpArticleLinkProps {
	icon: React.ReactElement,
	link?: string,
	text: string
}

export const OidcProviderHelpArticleLink: React.FC<OidcProviderHelpArticleLinkProps> = (props) => {
	const { icon, link, text } = props;

	return (
		<span>
			{
				link &&
					<a
						className='oidc-help-article-link'
						href={ link }
						rel='noopener norefererr'
						target='_blank'>
						{ icon }<span>{ text }</span>
					</a>
			}
		</span>
	);
};

